
import { Vue, Component } from 'vue-property-decorator';
import {
  getCompanyInfo,
  getCompanyDetail,
  incrementIRView,
  addCompanyLog,
} from '@/api/company';
import { ICompanyLog } from '@/types/company';
import { UserModule } from '@/store/user';
import { getUserInfo } from '@/api/user';
import PdfViewer from '@/components/PdfViewer.vue';

@Component({
  components: {
    PdfViewer,
  },
})
export default class IrdataDetail extends Vue {
  private coUid = '';

  private coData: any = [];

  private uData: any = [];

  private frCname = '';

  private toCname = '';

  private sort = '';

  private isLoading = true;

  private pageNum = 1;

  private totalPage = 0;

  get imagePath() {
    return `${process.env.VUE_APP_COMMON_API}/attached-file`;
  }

  // PDF 로드 완료 시 호출되는 함수
  private onPdfLoaded() {
    this.isLoading = false;

    // PdfViewer 컴포넌트 접근하여 전체 페이지 수 계산
    const viewer: any = this.$refs.pdfViewer;

    if (viewer) {
      if (viewer.numPages) {
        this.totalPage = viewer.numPages;
      } else if (viewer.images && viewer.images.length > 0) {
        this.totalPage = viewer.images.length;
      } else {
        this.totalPage = 1;
      }
    }
  }

  async created() {
    if (!UserModule.token) {
      alert('로그인이 필요한 페이지입니다.');
      this.$router.push({ name: 'Login' });
      return;
    }

    if (this.$route.params.irdataUid) {
      this.coUid = this.$route.params.irdataUid as string;
      this.incrementView(this.coUid);
    } else {
      // console.log('회사 라우트 파라미터가 없습니다.');
    }

    const res = await getCompanyDetail(this.coUid);
    this.coData = res.data;
    this.toCname = this.coData.coName || '';
    // 데이터 로드 시점에는 로딩 시작
    this.isLoading = true;

    if (this.coData.texts) {
      this.coData.coMember = this.coData.texts
        .filter((t: any) => t.part === 'coMember')
        .map((t: any) => t.content);
    } else {
      this.coData.coMember = [];
    }

    if (UserModule.token) {
      const uRes = await getUserInfo();
      const { uid } = uRes.data;

      if (uid) {
        UserModule.setUserUid(uid);
        const ucRes = await getCompanyInfo(uid);
        this.uData = ucRes.data;
        this.frCname = this.uData.coName || '';
      }
    }

    this.sendLog('IR 자료 보기');
  }

  private async incrementView(uid: string) {
    try {
      await incrementIRView(uid);
    } catch (error) {
      console.error(`회사 UID: ${uid} 조회수 증가 요청 실패:`, error);
    }
  }

  public calculateSort() {
    if (this.coData?.coDept && this.uData?.coDept) {
      this.sort = `${this.uData.coDept}${this.coData.coDept}`;
    }
  }

  private async logCompanyAction(data: ICompanyLog) {
    try {
      await addCompanyLog(data);
    } catch (error) {
      console.error('로그 추가 실패:', error);
    }
  }

  private sendLog(part: string) {
    this.calculateSort();
    const logData: ICompanyLog = {
      part,
      frCname: this.frCname,
      toCname: this.toCname,
      sort: this.sort,
    };
    this.logCompanyAction(logData);
  }

  private getThumnail(inputValue: string) {
    if (inputValue.startsWith('http')) return inputValue;
    return `${this.imagePath}/${inputValue}`;
  }
}
